/* eslint no-use-before-define: ["error", { "variables": false }] */

import { StyleSheet, Text, View } from 'react-native-web';

import Color from './Color';
import InputToolbarButton from './InputToolbarButton';
import PropTypes from 'prop-types';
import React from 'react';

export default class Actions extends React.Component {
  constructor(props) {
    super(props);
    this.onActionsPress = this.onActionsPress.bind(this);
  }

  onActionsPress() {
    /* GT -- the context doesn't work
    const { options } = this.props;
    const optionKeys = Object.keys(options);
    const cancelButtonIndex = optionKeys.indexOf('Cancel');

    this.context.actionSheet().showActionSheetWithOptions(
      {
        options: optionKeys,
        cancelButtonIndex,
        tintColor: this.props.optionTintColor
      },
      (buttonIndex) => {
        const key = optionKeys[buttonIndex];
        if (key) {
          options[key](this.props);
        }
      }
    );
    */
  }

  render() {
    const { label, renderActionIcon, renderActionHoverIcon, onPressActionButton, disabled } = this.props;

    // 如果没有提供图标，使用默认的+图标
    if (!renderActionIcon) {
      return (
        <View style={[styles.container, this.props.containerStyle]}>
          <View
            style={[styles.wrapper, this.props.wrapperStyle, disabled && styles.disabled]}
            onClick={disabled ? undefined : onPressActionButton || this.onActionsPress}
          >
            <Text style={[styles.iconText, this.props.iconTextStyle]}>+</Text>
          </View>
          {label && <Text style={[styles.label, disabled && styles.disabled]}>{label}</Text>}
        </View>
      );
    }

    // 使用统一的InputToolbarButton组件
    return (
      <View style={[styles.container, this.props.containerStyle]}>
        <InputToolbarButton
          onPress={onPressActionButton || this.onActionsPress}
          renderIcon={renderActionIcon}
          renderHoverIcon={renderActionHoverIcon}
          label={label}
          testID='action-button'
          accessibilityLabel='Action'
          disabled={disabled}
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    width: 26,
    minHeight: 26,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  touchable: {
    width: 26,
    height: 26
  },
  wrapper: {
    borderRadius: 13,
    borderColor: Color.defaultColor,
    borderWidth: 2,
    flex: 1
  },
  iconText: {
    color: Color.defaultColor,
    fontWeight: 'bold',
    fontSize: 16,
    backgroundColor: Color.backgroundTransparent,
    textAlign: 'center'
  },
  label: {
    fontSize: 9,
    color: Color.text,
    marginTop: 2,
    textAlign: 'center',
    whiteSpace: 'nowrap'
  },
  disabled: {
    opacity: 0.5
  }
});

// Removed contextTypes - not used (actionSheet is commented out)
// Actions.contextTypes = {
//   actionSheet: PropTypes.func
// };

Actions.defaultProps = {
  onSend: () => {},
  options: {},
  optionTintColor: Color.optionTintColor,
  renderActionIcon: null,
  renderActionHoverIcon: null,
  icon: null,
  containerStyle: {},
  iconTextStyle: {},
  wrapperStyle: {},
  label: null,
  disabled: false
};

Actions.propTypes = {
  onSend: PropTypes.func,
  options: PropTypes.object,
  optionTintColor: PropTypes.string,
  renderActionIcon: PropTypes.func,
  renderActionHoverIcon: PropTypes.func,
  icon: PropTypes.func,
  onPressActionButton: PropTypes.func,
  label: PropTypes.string,
  disabled: PropTypes.bool
  /*
  wrapperStyle: ViewPropTypes.style,
  containerStyle: ViewPropTypes.style,
*/
  //iconTextStyle: Text.propTypes.style,
};
